module.exports = __webpack_public_path__ + "static/media/gM6.13744d20.jpg";